import _ from 'lodash';
import Vue from 'vue';

export const state = () => ({
  featuredEvents: [],
  mainEvents: [],
  homeTabs: [],
  sports: [],
  eventsInfo: []
})

export const mutations = {
  setFeaturedEvents(state, featuredEvents) {
    state.featuredEvents = featuredEvents;
  },
  setMainEvents(state, mainEvents) {
    state.mainEvents = mainEvents;
  },
  setHomeTabs(state, homeTabs) {
    state.homeTabs = homeTabs;
  },
  setSports(state, sports) {
    state.sports = sports;
  },
  setEventsInfo(state, events_info) {
    state.eventsInfo = events_info
  }
}